import { CopyToClipboardWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('CopyToClipboard')
export class CopyToClipboardNodeSchemaProvider extends SchemaProvider<CopyToClipboardWorkflowNode> {}
